import {IComponentOptions} from 'angular';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import {IStateService} from 'angular-ui-router';
import {IAnlaufstelleStateParams} from '../../anlaufstelleverwaltung.route';
import RoleUtilService from '../../../core/service/RoleUtilService';
import {ApplicationPropertyRS} from '../../../admin/service/applicationPropertyRS.rest';
import ITranslateService = angular.translate.ITranslateService;

let template = require('./anlaufstelleverwaltungView.html');
require('./anlaufstelleverwaltungView.scss');

export class AnlaufstelleverwaltungViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = AnlaufstelleverwaltungViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        anlaufstellen: '<',
        vereinbarungMissing: '<'  //eigentlich unused jetzt
    };
}

export class AnlaufstelleverwaltungViewController {
    anlaufstellen: Array<TSAnlaufstelle>;
    vereinbarungMissing: Array<TSAnlaufstelle>;
    vereinbarungValid: number = 0;

    static $inject = ['AnlaufstelleRS', '$state', 'RoleUtilService', '$translate', 'ApplicationPropertyRS'];

    /* @ngInject */
    constructor(private anlaufstelleRS: AnlaufstelleRS, private $state: IStateService,
                private roleUtilService: RoleUtilService, private $translate: ITranslateService, private applicationPropertyRS: ApplicationPropertyRS) {
    }

    $onInit() {
        this.checkIfHasNeverHadVereinbarung();

        this.applicationPropertyRS.getVereinbarungValidYears().then((response) => {
            this.vereinbarungValid = response;
        });
    }

    private checkIfHasNeverHadVereinbarung(): boolean {
        if (this.anlaufstellen === null || this.anlaufstellen === undefined || this.anlaufstellen.length === 0) {
            return false;
        } else {
            let anlaufstellenWithoutVereinbarung = this.anlaufstellen.filter((anlaufstelle) => anlaufstelle.vereinbarungAkzeptiert === undefined);
            return anlaufstellenWithoutVereinbarung.length === this.anlaufstellen.length;
        }
    }

    private hasAnlaufstelleWithInvalidVereinbarung(): boolean {
        if (this.anlaufstellen === null || this.anlaufstellen === undefined || this.anlaufstellen.length === 0) {
            return false;
        }
        return this.anlaufstellen.filter((anlaufstelle) => anlaufstelle.isInvalidVereinbarung(this.vereinbarungValid)).length !== 0;
    }

    public editAnlaufstelle(anlaufstelle: TSAnlaufstelle, event: any) {
        let params: IAnlaufstelleStateParams;
        params = {createNew: false, anlaufstelleId: anlaufstelle.id, anlaufstelle: anlaufstelle};
        this.$state.go('anlaufstelle', params);
    }

    public addAnlaufstelle() {
        let params: IAnlaufstelleStateParams;
        params = {createNew: true, anlaufstelleId: '', anlaufstelle: undefined};
        this.$state.go('anlaufstelle', params);
    }

    public getVereinbarungText(): string {
        return this.$translate.instant('VEREINBARUNG_ABGELAUFEN_WARNUNG',
            undefined, undefined, 'none');

    }

    public getVereinbarungStep1Text(): string {
        let text = this.$translate.instant('VEREIBARUNG_STEP1_TEXT');
        console.log(text);
        return text
    }
}



// WEBPACK FOOTER //
// ./src/app/anlaufstelleverwaltung/component/anlaufstelleverwaltungView/anlaufstelleverwaltungView.ts